document.addEventListener("DOMContentLoaded", function () {

  const slider = document.querySelector(".essentials-swiper");

  if (!slider) return;

  if (typeof Swiper === "undefined") {
    console.error("Swiper library not loaded.");
    return;
  }

  new Swiper(".essentials-swiper", {

    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 500,
    grabCursor: true,

    navigation: {
      nextEl: ".essentials-next",
      prevEl: ".essentials-prev"
    },

    pagination: {
      el: ".essentials-pagination",
      clickable: true
    }

  });

  document.querySelectorAll(".essential-add").forEach((button) => {

    button.addEventListener("click", async function () {

      const variantId = this.dataset.id;
      const btn = this;

      btn.disabled = true;
      btn.innerHTML = "Adding...";

      try {

        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });

        if (!response.ok) {
          throw new Error("Failed to add product");
        }

        btn.innerHTML = "✓ Added";

        /* Refresh Dawn cart drawer */
        document.dispatchEvent(new CustomEvent("cart:refresh"));

        /* Optional: Open cart drawer if your theme supports it */
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer && typeof cartDrawer.open === "function") {
          cartDrawer.open();
        }

        setTimeout(() => {
          btn.innerHTML = "Add";
          btn.disabled = false;
        }, 1500);

      } catch (error) {

        console.error(error);

        btn.innerHTML = "Error";

        setTimeout(() => {
          btn.innerHTML = "Add";
          btn.disabled = false;
        }, 1500);

      }

    });

  });

});